window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.SplashScreen = function() {
	this.initialize(img.SplashAssets_SplashScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1920,1080);


(lib.startDisabled = function() {
	this.initialize(img.SplashAssets_startDisabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,308,62);


(lib.startOver = function() {
	this.initialize(img.SplashAssets_startOver);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,308,62);


(lib.startUp = function() {
	this.initialize(img.SplashAssets_startUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,308,62);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.LoadingIndicator = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.loadingDotsTextField = new cjs.Text("...", "bold 22px 'Work Sans'", "#324141");
	this.loadingDotsTextField.name = "loadingDotsTextField";
	this.loadingDotsTextField.textAlign = "center";
	this.loadingDotsTextField.lineHeight = 27;
	this.loadingDotsTextField.lineWidth = 20;
	this.loadingDotsTextField.parent = this;
	this.loadingDotsTextField.setTransform(114.65,2);
ranj.TextOffsetFixer.fix(this.loadingDotsTextField);

	this.loadingTextField = new cjs.Text("Loading", "bold 22px 'Work Sans'", "#324141");
	this.loadingTextField.name = "loadingTextField";
	this.loadingTextField.textAlign = "right";
	this.loadingTextField.lineHeight = 27;
	this.loadingTextField.lineWidth = 99;
	this.loadingTextField.parent = this;
	this.loadingTextField.setTransform(100.85,2);
ranj.TextOffsetFixer.fix(this.loadingTextField);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FAF5F0").s().p("ArXCmIAAlLIWvAAIAAFLg");
	this.shape.setTransform(72.75,16.625);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.loadingTextField},{t:this.loadingDotsTextField}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LoadingIndicator, new cjs.Rectangle(0,0,145.5,33.3), null);


(lib.LoadingBar = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// LoadingBarBar (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AgYBaIAAhQIBPAAIAABQg");
	var mask_graphics_1 = new cjs.Graphics().p("AhWBaIAAhQIDLAAIAABQg");
	var mask_graphics_2 = new cjs.Graphics().p("AiUBaIAAhQIFHAAIAABQg");
	var mask_graphics_3 = new cjs.Graphics().p("AjSBaIAAhQIHDAAIAABQg");
	var mask_graphics_4 = new cjs.Graphics().p("AkQBaIAAhQII/AAIAABQg");
	var mask_graphics_5 = new cjs.Graphics().p("AlOBaIAAhQIK7AAIAABQg");
	var mask_graphics_6 = new cjs.Graphics().p("AmMBaIAAhQIM3AAIAABQg");
	var mask_graphics_7 = new cjs.Graphics().p("AnKBaIAAhQIOzAAIAABQg");
	var mask_graphics_8 = new cjs.Graphics().p("AoJBaIAAhQIQxAAIAABQg");
	var mask_graphics_9 = new cjs.Graphics().p("ApHBaIAAhQIStAAIAABQg");
	var mask_graphics_10 = new cjs.Graphics().p("AqFBaIAAhQIUpAAIAABQg");
	var mask_graphics_11 = new cjs.Graphics().p("ArDBaIAAhQIWlAAIAABQg");
	var mask_graphics_12 = new cjs.Graphics().p("AsBBaIAAhQIYhAAIAABQg");
	var mask_graphics_13 = new cjs.Graphics().p("As/BaIAAhQIadAAIAABQg");
	var mask_graphics_14 = new cjs.Graphics().p("At9BaIAAhQIcZAAIAABQg");
	var mask_graphics_15 = new cjs.Graphics().p("Au7BaIAAhQIeVAAIAABQg");
	var mask_graphics_16 = new cjs.Graphics().p("Av5BaIAAhQMAgRAAAIAABQg");
	var mask_graphics_17 = new cjs.Graphics().p("Aw3BaIAAhQMAiNAAAIAABQg");
	var mask_graphics_18 = new cjs.Graphics().p("Ax1BaIAAhQMAkJAAAIAABQg");
	var mask_graphics_19 = new cjs.Graphics().p("AyzBaIAAhQMAmFAAAIAABQg");
	var mask_graphics_20 = new cjs.Graphics().p("AzxBaIAAhQMAoBAAAIAABQg");
	var mask_graphics_21 = new cjs.Graphics().p("A0vBaIAAhQMAp9AAAIAABQg");
	var mask_graphics_22 = new cjs.Graphics().p("A1tBaIAAhQMAr5AAAIAABQg");
	var mask_graphics_23 = new cjs.Graphics().p("A2rBaIAAhQMAt1AAAIAABQg");
	var mask_graphics_24 = new cjs.Graphics().p("A3pBaIAAhQMAvxAAAIAABQg");
	var mask_graphics_25 = new cjs.Graphics().p("A4nBaIAAhQMAxtAAAIAABQg");
	var mask_graphics_26 = new cjs.Graphics().p("A5lBaIAAhQMAzpAAAIAABQg");
	var mask_graphics_27 = new cjs.Graphics().p("A6jBaIAAhQMA1lAAAIAABQg");
	var mask_graphics_28 = new cjs.Graphics().p("A7hBaIAAhQMA3hAAAIAABQg");
	var mask_graphics_29 = new cjs.Graphics().p("A8fBaIAAhQMA5dAAAIAABQg");
	var mask_graphics_30 = new cjs.Graphics().p("A9dBaIAAhQMA7ZAAAIAABQg");
	var mask_graphics_31 = new cjs.Graphics().p("A+bBaIAAhQMA9VAAAIAABQg");
	var mask_graphics_32 = new cjs.Graphics().p("A/ZBaIAAhQMA/RAAAIAABQg");
	var mask_graphics_33 = new cjs.Graphics().p("EggXABaIAAhQMBBNAAAIAABQg");
	var mask_graphics_34 = new cjs.Graphics().p("EghVABaIAAhQMBDJAAAIAABQg");
	var mask_graphics_35 = new cjs.Graphics().p("EgiTABaIAAhQMBFFAAAIAABQg");
	var mask_graphics_36 = new cjs.Graphics().p("EgjRABaIAAhQMBHBAAAIAABQg");
	var mask_graphics_37 = new cjs.Graphics().p("EgkPABaIAAhQMBI9AAAIAABQg");
	var mask_graphics_38 = new cjs.Graphics().p("EglNABaIAAhQMBK5AAAIAABQg");
	var mask_graphics_39 = new cjs.Graphics().p("EgmLABaIAAhQMBM1AAAIAABQg");
	var mask_graphics_40 = new cjs.Graphics().p("EgnJABaIAAhQMBOxAAAIAABQg");
	var mask_graphics_41 = new cjs.Graphics().p("EgoHABaIAAhQMBQtAAAIAABQg");
	var mask_graphics_42 = new cjs.Graphics().p("EgpFABaIAAhQMBSpAAAIAABQg");
	var mask_graphics_43 = new cjs.Graphics().p("EgqDABaIAAhQMBUlAAAIAABQg");
	var mask_graphics_44 = new cjs.Graphics().p("EgrBABaIAAhQMBWhAAAIAABQg");
	var mask_graphics_45 = new cjs.Graphics().p("Egr/ABaIAAhQMBYdAAAIAABQg");
	var mask_graphics_46 = new cjs.Graphics().p("Egs9ABaIAAhQMBaZAAAIAABQg");
	var mask_graphics_47 = new cjs.Graphics().p("Egt7ABaIAAhQMBcVAAAIAABQg");
	var mask_graphics_48 = new cjs.Graphics().p("Egu5ABaIAAhQMBeRAAAIAABQg");
	var mask_graphics_49 = new cjs.Graphics().p("Egv3ABaIAAhQMBgNAAAIAABQg");
	var mask_graphics_50 = new cjs.Graphics().p("Egw1ABaIAAhQMBiJAAAIAABQg");
	var mask_graphics_51 = new cjs.Graphics().p("Egx0ABaIAAhQMBkGAAAIAABQg");
	var mask_graphics_52 = new cjs.Graphics().p("EgyyABaIAAhQMBmDAAAIAABQg");
	var mask_graphics_53 = new cjs.Graphics().p("EgzwABaIAAhQMBn/AAAIAABQg");
	var mask_graphics_54 = new cjs.Graphics().p("Eg0uABaIAAhQMBp7AAAIAABQg");
	var mask_graphics_55 = new cjs.Graphics().p("Eg1sABaIAAhQMBr3AAAIAABQg");
	var mask_graphics_56 = new cjs.Graphics().p("Eg2qABaIAAhQMBtzAAAIAABQg");
	var mask_graphics_57 = new cjs.Graphics().p("Eg3oABaIAAhQMBvvAAAIAABQg");
	var mask_graphics_58 = new cjs.Graphics().p("Eg4mABaIAAhQMBxrAAAIAABQg");
	var mask_graphics_59 = new cjs.Graphics().p("Eg5kABaIAAhQMBznAAAIAABQg");
	var mask_graphics_60 = new cjs.Graphics().p("Eg6iABaIAAhQMB1jAAAIAABQg");
	var mask_graphics_61 = new cjs.Graphics().p("Eg7gABaIAAhQMB3fAAAIAABQg");
	var mask_graphics_62 = new cjs.Graphics().p("Eg8eABaIAAhQMB5bAAAIAABQg");
	var mask_graphics_63 = new cjs.Graphics().p("Eg9cABaIAAhQMB7XAAAIAABQg");
	var mask_graphics_64 = new cjs.Graphics().p("Eg+aABaIAAhQMB9TAAAIAABQg");
	var mask_graphics_65 = new cjs.Graphics().p("Eg/YABaIAAhQMB/PAAAIAABQg");
	var mask_graphics_66 = new cjs.Graphics().p("EhAWABaIAAhQMCBLAAAIAABQg");
	var mask_graphics_67 = new cjs.Graphics().p("EhBUABaIAAhQMCDHAAAIAABQg");
	var mask_graphics_68 = new cjs.Graphics().p("EhCSABaIAAhQMCFDAAAIAABQg");
	var mask_graphics_69 = new cjs.Graphics().p("EhDQABaIAAhQMCG/AAAIAABQg");
	var mask_graphics_70 = new cjs.Graphics().p("EhEOABaIAAhQMCI7AAAIAABQg");
	var mask_graphics_71 = new cjs.Graphics().p("EhFMABaIAAhQMCK3AAAIAABQg");
	var mask_graphics_72 = new cjs.Graphics().p("EhGKABaIAAhQMCMzAAAIAABQg");
	var mask_graphics_73 = new cjs.Graphics().p("EhHIABaIAAhQMCOvAAAIAABQg");
	var mask_graphics_74 = new cjs.Graphics().p("EhIGABaIAAhQMCQrAAAIAABQg");
	var mask_graphics_75 = new cjs.Graphics().p("EhJEABaIAAhQMCSnAAAIAABQg");
	var mask_graphics_76 = new cjs.Graphics().p("EhKCABaIAAhQMCUjAAAIAABQg");
	var mask_graphics_77 = new cjs.Graphics().p("EhLAABaIAAhQMCWfAAAIAABQg");
	var mask_graphics_78 = new cjs.Graphics().p("EhL+ABaIAAhQMCYbAAAIAABQg");
	var mask_graphics_79 = new cjs.Graphics().p("EhM8ABaIAAhQMCaXAAAIAABQg");
	var mask_graphics_80 = new cjs.Graphics().p("EhN6ABaIAAhQMCcTAAAIAABQg");
	var mask_graphics_81 = new cjs.Graphics().p("EhO4ABaIAAhQMCePAAAIAABQg");
	var mask_graphics_82 = new cjs.Graphics().p("EhP2ABaIAAhQMCgLAAAIAABQg");
	var mask_graphics_83 = new cjs.Graphics().p("EhQ0ABaIAAhQMCiHAAAIAABQg");
	var mask_graphics_84 = new cjs.Graphics().p("EhRyABaIAAhQMCkDAAAIAABQg");
	var mask_graphics_85 = new cjs.Graphics().p("EhSwABaIAAhQMCl/AAAIAABQg");
	var mask_graphics_86 = new cjs.Graphics().p("EhTuABaIAAhQMCn7AAAIAABQg");
	var mask_graphics_87 = new cjs.Graphics().p("EhUsABaIAAhQMCp3AAAIAABQg");
	var mask_graphics_88 = new cjs.Graphics().p("EhVqABaIAAhQMCrzAAAIAABQg");
	var mask_graphics_89 = new cjs.Graphics().p("EhWoABaIAAhQMCtvAAAIAABQg");
	var mask_graphics_90 = new cjs.Graphics().p("EhXmABaIAAhQMCvrAAAIAABQg");
	var mask_graphics_91 = new cjs.Graphics().p("EhYkABaIAAhQMCxnAAAIAABQg");
	var mask_graphics_92 = new cjs.Graphics().p("EhZiABaIAAhQMCzjAAAIAABQg");
	var mask_graphics_93 = new cjs.Graphics().p("EhagABaIAAhQMC1fAAAIAABQg");
	var mask_graphics_94 = new cjs.Graphics().p("EhbeABaIAAhQMC3bAAAIAABQg");
	var mask_graphics_95 = new cjs.Graphics().p("EhcdABaIAAhQMC5YAAAIAABQg");
	var mask_graphics_96 = new cjs.Graphics().p("EhdbABaIAAhQMC7VAAAIAABQg");
	var mask_graphics_97 = new cjs.Graphics().p("EheZABaIAAhQMC9RAAAIAABQg");
	var mask_graphics_98 = new cjs.Graphics().p("EhfXABaIAAhQMC/NAAAIAABQg");
	var mask_graphics_99 = new cjs.Graphics().p("EhgVABaIAAhQMDBJAAAIAABQg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:5.5334,y:9}).wait(1).to({graphics:mask_graphics_1,x:11.7356,y:9}).wait(1).to({graphics:mask_graphics_2,x:17.9379,y:9}).wait(1).to({graphics:mask_graphics_3,x:24.1402,y:9}).wait(1).to({graphics:mask_graphics_4,x:30.3425,y:9}).wait(1).to({graphics:mask_graphics_5,x:36.5448,y:9}).wait(1).to({graphics:mask_graphics_6,x:42.7471,y:9}).wait(1).to({graphics:mask_graphics_7,x:48.9493,y:9}).wait(1).to({graphics:mask_graphics_8,x:55.1516,y:9}).wait(1).to({graphics:mask_graphics_9,x:61.3539,y:9}).wait(1).to({graphics:mask_graphics_10,x:67.5562,y:9}).wait(1).to({graphics:mask_graphics_11,x:73.7585,y:9}).wait(1).to({graphics:mask_graphics_12,x:79.9608,y:9}).wait(1).to({graphics:mask_graphics_13,x:86.163,y:9}).wait(1).to({graphics:mask_graphics_14,x:92.3653,y:9}).wait(1).to({graphics:mask_graphics_15,x:98.5676,y:9}).wait(1).to({graphics:mask_graphics_16,x:104.7699,y:9}).wait(1).to({graphics:mask_graphics_17,x:110.9722,y:9}).wait(1).to({graphics:mask_graphics_18,x:117.1745,y:9}).wait(1).to({graphics:mask_graphics_19,x:123.3768,y:9}).wait(1).to({graphics:mask_graphics_20,x:129.579,y:9}).wait(1).to({graphics:mask_graphics_21,x:135.7813,y:9}).wait(1).to({graphics:mask_graphics_22,x:141.9836,y:9}).wait(1).to({graphics:mask_graphics_23,x:148.1859,y:9}).wait(1).to({graphics:mask_graphics_24,x:154.3882,y:9}).wait(1).to({graphics:mask_graphics_25,x:160.5905,y:9}).wait(1).to({graphics:mask_graphics_26,x:166.7927,y:9}).wait(1).to({graphics:mask_graphics_27,x:172.995,y:9}).wait(1).to({graphics:mask_graphics_28,x:179.1973,y:9}).wait(1).to({graphics:mask_graphics_29,x:185.3996,y:9}).wait(1).to({graphics:mask_graphics_30,x:191.6019,y:9}).wait(1).to({graphics:mask_graphics_31,x:197.8042,y:9}).wait(1).to({graphics:mask_graphics_32,x:204.0065,y:9}).wait(1).to({graphics:mask_graphics_33,x:210.2087,y:9}).wait(1).to({graphics:mask_graphics_34,x:216.411,y:9}).wait(1).to({graphics:mask_graphics_35,x:222.6133,y:9}).wait(1).to({graphics:mask_graphics_36,x:228.8156,y:9}).wait(1).to({graphics:mask_graphics_37,x:235.0179,y:9}).wait(1).to({graphics:mask_graphics_38,x:241.2202,y:9}).wait(1).to({graphics:mask_graphics_39,x:247.4224,y:9}).wait(1).to({graphics:mask_graphics_40,x:253.6247,y:9}).wait(1).to({graphics:mask_graphics_41,x:259.827,y:9}).wait(1).to({graphics:mask_graphics_42,x:266.0293,y:9}).wait(1).to({graphics:mask_graphics_43,x:272.2316,y:9}).wait(1).to({graphics:mask_graphics_44,x:278.4339,y:9}).wait(1).to({graphics:mask_graphics_45,x:284.6361,y:9}).wait(1).to({graphics:mask_graphics_46,x:290.8384,y:9}).wait(1).to({graphics:mask_graphics_47,x:297.0407,y:9}).wait(1).to({graphics:mask_graphics_48,x:303.243,y:9}).wait(1).to({graphics:mask_graphics_49,x:309.4453,y:9}).wait(1).to({graphics:mask_graphics_50,x:315.6476,y:9}).wait(1).to({graphics:mask_graphics_51,x:321.8498,y:9}).wait(1).to({graphics:mask_graphics_52,x:328.0521,y:9}).wait(1).to({graphics:mask_graphics_53,x:334.2544,y:9}).wait(1).to({graphics:mask_graphics_54,x:340.4567,y:9}).wait(1).to({graphics:mask_graphics_55,x:346.659,y:9}).wait(1).to({graphics:mask_graphics_56,x:352.8613,y:9}).wait(1).to({graphics:mask_graphics_57,x:359.0636,y:9}).wait(1).to({graphics:mask_graphics_58,x:365.2658,y:9}).wait(1).to({graphics:mask_graphics_59,x:371.4681,y:9}).wait(1).to({graphics:mask_graphics_60,x:377.6704,y:9}).wait(1).to({graphics:mask_graphics_61,x:383.8727,y:9}).wait(1).to({graphics:mask_graphics_62,x:390.075,y:9}).wait(1).to({graphics:mask_graphics_63,x:396.2773,y:9}).wait(1).to({graphics:mask_graphics_64,x:402.4795,y:9}).wait(1).to({graphics:mask_graphics_65,x:408.6818,y:9}).wait(1).to({graphics:mask_graphics_66,x:414.8841,y:9}).wait(1).to({graphics:mask_graphics_67,x:421.0864,y:9}).wait(1).to({graphics:mask_graphics_68,x:427.2887,y:9}).wait(1).to({graphics:mask_graphics_69,x:433.491,y:9}).wait(1).to({graphics:mask_graphics_70,x:439.6932,y:9}).wait(1).to({graphics:mask_graphics_71,x:445.8955,y:9}).wait(1).to({graphics:mask_graphics_72,x:452.0978,y:9}).wait(1).to({graphics:mask_graphics_73,x:458.3001,y:9}).wait(1).to({graphics:mask_graphics_74,x:464.5024,y:9}).wait(1).to({graphics:mask_graphics_75,x:470.7047,y:9}).wait(1).to({graphics:mask_graphics_76,x:476.907,y:9}).wait(1).to({graphics:mask_graphics_77,x:483.1092,y:9}).wait(1).to({graphics:mask_graphics_78,x:489.3115,y:9}).wait(1).to({graphics:mask_graphics_79,x:495.5138,y:9}).wait(1).to({graphics:mask_graphics_80,x:501.7161,y:9}).wait(1).to({graphics:mask_graphics_81,x:507.9184,y:9}).wait(1).to({graphics:mask_graphics_82,x:514.1207,y:9}).wait(1).to({graphics:mask_graphics_83,x:520.3229,y:9}).wait(1).to({graphics:mask_graphics_84,x:526.5252,y:9}).wait(1).to({graphics:mask_graphics_85,x:532.7275,y:9}).wait(1).to({graphics:mask_graphics_86,x:538.9298,y:9}).wait(1).to({graphics:mask_graphics_87,x:545.1321,y:9}).wait(1).to({graphics:mask_graphics_88,x:551.3344,y:9}).wait(1).to({graphics:mask_graphics_89,x:557.5366,y:9}).wait(1).to({graphics:mask_graphics_90,x:563.7389,y:9}).wait(1).to({graphics:mask_graphics_91,x:569.9412,y:9}).wait(1).to({graphics:mask_graphics_92,x:576.1435,y:9}).wait(1).to({graphics:mask_graphics_93,x:582.3458,y:9}).wait(1).to({graphics:mask_graphics_94,x:588.5481,y:9}).wait(1).to({graphics:mask_graphics_95,x:594.7503,y:9}).wait(1).to({graphics:mask_graphics_96,x:600.9526,y:9}).wait(1).to({graphics:mask_graphics_97,x:607.1549,y:9}).wait(1).to({graphics:mask_graphics_98,x:613.3572,y:9}).wait(1).to({graphics:mask_graphics_99,x:619.5595,y:9}).wait(1));

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FCFAF7").s().p("EgkRACnIAAgpIAAjnIAAg8MBIjAAAIAAFMg");
	this.shape.setTransform(1014.575,14.65);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#F2E4D5").s().p("Eg9bAB0IAAjnMB63AAAIAADng");
	this.shape_1.setTransform(389.2,15.675);

	var maskedShapeInstanceList = [this.shape,this.shape_1];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(100));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,7,1239.1,13);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EiV/hUXMEr/AAAMAAACovMkr/AAAg");

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("EiV/BUYMAAAiovMEr/AAAMAAACovg");

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-961,-541,1922,1082), null);


(lib.PlaceholderButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// DisabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Start simulation", "bold 24px 'Open Sans'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 37;
	this.disabledLabelTextField.lineWidth = 195;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-30.3,-17.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// DownLabelTextField
	this.downLabelTextField = new cjs.Text("Start simulation", "bold 24px 'Open Sans'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 37;
	this.downLabelTextField.lineWidth = 195;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-30.3,-17.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Start simulation", "bold 24px 'Open Sans'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 37;
	this.overLabelTextField.lineWidth = 195;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-30.3,-17.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Start simulation", "bold 24px 'Open Sans'", "#324141");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 37;
	this.upLabelTextField.lineWidth = 195;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-30.3,-17.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Layer_4
	this.instance = new lib.startUp();
	this.instance.setTransform(-150,-31);

	this.instance_1 = new lib.startOver();
	this.instance_1.setTransform(-152,-32);

	this.instance_2 = new lib.startDisabled();
	this.instance_2.setTransform(-152,-32);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-152,-32,310,63);


(lib.SplashLoadScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startButton
	this.startButton = new lib.PlaceholderButton();
	this.startButton.name = "startButton";
	this.startButton.setTransform(-0.5,332.6,1,1,0,0,0,-0.5,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.startButton).wait(1));

	// Layer_7
	this.loadingIndicator = new lib.LoadingIndicator();
	this.loadingIndicator.name = "loadingIndicator";
	this.loadingIndicator.setTransform(-564.2,196.85,1,1,0,0,0,72.8,16.6);

	this.timeline.addTween(cjs.Tween.get(this.loadingIndicator).wait(1));

	// loadingBar
	this.loadingBar = new lib.LoadingBar();
	this.loadingBar.name = "loadingBar";
	this.loadingBar.setTransform(-462.25,144.7,1,1,0,0,0,157.5,12.2);

	this.timeline.addTween(cjs.Tween.get(this.loadingBar).wait(1));

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#B79886").s().p("EhgjAAoIAAhPMDBGAAAIAABPg");
	this.shape.setTransform(1.2,146.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// background
	this.instance = new lib.SplashScreen();
	this.instance.setTransform(-960,-540);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SplashLoadScreenSkin, new cjs.Rectangle(-960.5,-540.5,1921,1081), null);


// stage content:
(lib.SplashAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-0.5,-0.5,961,541);
// library properties:
lib.properties = {
	id: '2D758ABF18A3194E856740076AC96F36',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SplashAssets/SplashScreen.png", id:"SplashAssets_SplashScreen", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/startDisabled.png", id:"SplashAssets_startDisabled", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/startOver.png", id:"SplashAssets_startOver", bundle:"SplashAssets"},
		{src:"assets/skins/images/SplashAssets/startUp.png", id:"SplashAssets_startUp", bundle:"SplashAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.SplashAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.SplashAssets;